"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    includes: ()=>includes,
    isDistinctIdStringLike: ()=>isDistinctIdStringLike,
    stripLeadingDollar: ()=>stripLeadingDollar,
    trim: ()=>trim
});
function includes(str, needle) {
    return -1 !== str.indexOf(needle);
}
const trim = function(str) {
    return str.trim();
};
const stripLeadingDollar = function(s) {
    return s.replace(/^\$/, '');
};
function isDistinctIdStringLike(value) {
    return [
        'distinct_id',
        'distinctid'
    ].includes(value.toLowerCase());
}
exports.includes = __webpack_exports__.includes;
exports.isDistinctIdStringLike = __webpack_exports__.isDistinctIdStringLike;
exports.stripLeadingDollar = __webpack_exports__.stripLeadingDollar;
exports.trim = __webpack_exports__.trim;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "includes",
    "isDistinctIdStringLike",
    "stripLeadingDollar",
    "trim"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
